
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/45108fa1-aa34-470a-a0f4-a8e2932a28e4.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('45108fa1-aa34-470a-a0f4-a8e2932a28e4');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      